
    <ng-select
      [(ngModel)]="value"
      [loading]="fetching$ | async"
      [typeahead]="typeahead$"
      [items]="items$ | async"
      appendTo="body"
      bindLabel="text"
      bindValue="id"
      (ngModelChange)="onChange()"
    >
      <ng-template ng-label-tmp let-item="item">
        {{ item.text | translate }}
      </ng-template>

      <ng-template
        ng-option-tmp
        let-item="item"
      >
        <fieldmagic-indent
          *ngIf="! item.is_parent"
        >
          <span>{{ item.text | translate }}</span>
        </fieldmagic-indent>

        <span *ngIf="item.is_parent">{{ item.text | translate }}</span>
      </ng-template>
    </ng-select>
  